// extracted by mini-css-extract-plugin
export default {"block":"FilterVaribleLogic_block__PQigR","select":"FilterVaribleLogic_select__LqRye","icon":"FilterVaribleLogic_icon__dJiPt"};